var removeHTML = function (html) {
    var text = html;
    if (!text) {
        return;
    }
    if (Array.isArray(text)) {
        text = text.join("");
    }
    if (typeof document === "undefined") {
        return text.replace(/<\/?[^>]+(>|$)/g, "");
    }
    var element = document.createElement("div");
    element.innerHTML = text;
    return element.textContent || element.innerText || "";
};
export default removeHTML;



//////////////////
// WEBPACK FOOTER
// ./app/modules/search/utils/removeHTML.ts
// module id = 6tpt
// module chunks = 2